export default __webpack_public_path__ + "static/media/certbg.f2832417.png";